import { describeVideoReview } from './describeTask';
import PlanTaskCard from './PlanTaskCard';
import TaskRow from './TaskRow';
import type { HomeTask } from './tasks';
import { videoReviewRoute } from './videoReviewRoute';
import type { Kitchen } from '../../libs';

type TaskCardProps = { task: HomeTask; kitchen: Kitchen; onOpen: (route: string) => void };

// The card for a task of any kind; each kind decides how it reads and whether it opens anywhere.
const TaskCard = ({ task, kitchen, onOpen }: TaskCardProps) => {
  switch (task.kind) {
    case 'videoReview': {
      return (
        <TaskRow
          description={describeVideoReview(task, kitchen)}
          done={task.doneAt !== undefined}
          onOpen={() => onOpen(videoReviewRoute(task.videoReview?.jobId ?? task.id))}
        />
      );
    }
    case 'productionPlan': {
      return <PlanTaskCard task={task} kitchen={kitchen} />;
    }
  }
};

export default TaskCard;
